import classNames from 'classnames'
import React, { useMemo } from 'react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import * as styles from './Swiper.module.scss'
import { colors } from '../../constants/style'
import 'swiper/scss';
import "swiper/scss/pagination"
import "swiper/scss/navigation"


function SwiperComponent ({ children, tabletSwiper, desktopSwiper, ...props }) {

  const mobileChildren = useMemo(() => {
    return children.map((child, index) => {
      return (
        <SwiperSlide key={index}>
          {child}
        </SwiperSlide>
      );
    });
  }, []);

  return (
    <div className={classNames(styles.swiperMobile, tabletSwiper && styles.swiperTablet, desktopSwiper && styles.swiperDesktop)}>
      <Swiper
        style={{
          '--swiper-pagination-bullet-horizontal-gap': '5px',
          '--swiper-navigation-size': '15px',
          '--swiper-navigation-color': colors.blue900,
        }}
        centerInsufficientSlides
        spaceBetween={50}
        pagination={{clickable: true}}
        modules={[Pagination, Autoplay, Navigation]}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2
          }
        }}
        {...props}
      >
        {mobileChildren}
      </Swiper>
    </div>
  );
}

export default SwiperComponent;
